function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.8824 14.2969C18.8059 14.4791 7.72949 22.7437 7.72949 39.052H52.0355C52.0355 22.7439 40.959 14.4792 29.8824 14.2969Z",
  fill: "#6D80AA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.0352 39.0527L48.9756 43.4391L51.6166 49.1518C54.4336 49.1906 57.6262 46.3129 57.6262 43.4933V41.2866C57.6262 40.0572 56.6128 39.0527 55.3726 39.0527H52.0352Z",
  fill: "#FFBC85"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.14209 41.2866V43.4933C2.14209 46.3128 5.33475 49.1906 8.14789 49.1518L11.501 44.1023L7.72925 39.0527H4.39185C3.15549 39.0527 2.14209 40.0572 2.14209 41.2866Z",
  fill: "#FFBC85"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.0098 14.328C38.4235 16.1547 46.8472 23.981 47.1954 37.7838C48.3927 38.4237 49.9303 38.9085 52.0352 39.052C52.0352 22.7439 40.9587 14.4792 29.8823 14.2969C29.5927 14.3009 29.3031 14.3124 29.0098 14.328Z",
  fill: "#49679B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5487 33.2277C15.3629 31.6493 16.697 38.4324 7.72949 39.0529V45.7701C7.72949 46.8677 7.87423 48.0002 8.14813 49.1521C9.84224 56.2725 16.4702 64.0021 24.3344 66.8913C26.3415 67.632 28.114 68.0005 29.8824 68.0005C31.6549 68.0005 33.4234 67.6321 35.4305 66.8913C43.2948 64.0019 49.9266 56.2725 51.6168 49.1521C51.8907 48.0002 52.0354 46.8677 52.0354 45.7701V39.0529C43.0677 38.4324 44.4059 31.6493 38.2162 33.2277C33.4311 34.4493 31.6626 35.0621 29.8824 35.0621C28.1061 35.0621 26.3338 34.4493 21.5487 33.2277Z",
  fill: "#FFE5C1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.2031 38.6713L47.2069 45.3886C47.2069 46.4823 47.0622 47.6186 46.7883 48.7705C45.0942 55.891 38.4624 63.6205 30.602 66.5097C29.1075 67.0605 27.7458 67.4017 26.4155 67.5452C27.6128 67.8478 28.7474 67.9991 29.8821 67.9991C31.6546 67.9991 33.423 67.6306 35.4301 66.8898C43.2945 64.0005 49.9263 56.2711 51.6164 49.1506C51.8903 47.9987 52.035 46.8662 52.035 45.7687V39.0514C49.93 38.908 48.3925 38.4231 47.1952 37.7832C47.2031 38.0779 47.2031 38.3728 47.2031 38.6713Z",
  fill: "#FED1A3"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.9957 25.6252C46.1117 27.8048 51.3429 27.1766 54.8133 23.7365C59.0623 19.5246 59.0623 12.6988 54.8133 8.49094C50.5681 4.27906 43.6821 4.27906 39.4329 8.49094C35.9625 11.9309 35.3286 17.1163 37.5274 21.1962L36.561 26.1798C36.471 26.6413 36.4632 26.6801 36.9288 26.5909L41.9957 25.6252Z",
  fill: "#FDB440"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M47.3639 19.6316C46.7972 19.6316 46.338 19.1726 46.338 18.6062V17.055C46.338 15.939 47.0457 15.1011 47.6145 14.4278C47.9514 14.029 48.3334 13.5768 48.3334 13.3125V12.3274C48.3334 11.5007 47.6511 10.828 46.8122 10.828C45.9713 10.828 45.2872 11.5007 45.2872 12.3274V13.3125C45.2872 13.8788 44.828 14.3378 44.2613 14.3378C43.6946 14.3378 43.2354 13.8788 43.2354 13.3125V12.3274C43.2354 10.3699 44.8399 8.77734 46.8122 8.77734C48.7823 8.77734 50.3852 10.3699 50.3852 12.3274V13.3125C50.3852 14.3266 49.7461 15.0831 49.1823 15.7505C48.7927 16.2118 48.3898 16.6887 48.3898 17.055V18.6062C48.3899 19.1727 47.9306 19.6316 47.3639 19.6316Z",
  fill: "#F8F2F0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M47.3677 23.33C46.801 23.33 46.3418 22.8728 46.3418 22.3065V22.3027C46.3418 21.7363 46.801 21.2773 47.3677 21.2773C47.9344 21.2773 48.3936 21.7363 48.3936 22.3027C48.3936 22.869 47.9343 23.33 47.3677 23.33Z",
  fill: "#F8F2F0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M32.7663 60.9778C32.4665 60.9778 32.1695 60.8473 31.9668 60.5958C31.1976 59.6421 29.3969 59.2333 28.1889 59.7388C27.6665 59.957 27.0651 59.7112 26.8464 59.1888C26.6277 58.6665 26.8739 58.0658 27.3967 57.8472C29.4537 56.9872 32.2207 57.6428 33.5644 59.3093C33.9199 59.7502 33.8506 60.3956 33.4093 60.751C33.2198 60.9036 32.9923 60.9778 32.7663 60.9778Z",
  fill: "#6D80AA"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M42.2704 42.5101C41.9254 42.5101 41.5888 42.3362 41.3949 42.0209C40.2767 40.1997 37.6982 39.693 35.9504 40.2673C35.4116 40.4441 34.8321 40.1516 34.6552 39.6139C34.478 39.076 34.771 38.4965 35.3092 38.3196C37.8535 37.483 41.4795 38.2378 43.1438 40.9485C43.4401 41.4311 43.289 42.0625 42.806 42.3587C42.6387 42.4612 42.4534 42.5101 42.2704 42.5101Z",
  fill: "#6D80AA"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.96 25.3116C14.8306 28.0303 8.30438 27.2468 3.97327 22.9575C-1.32442 17.7064 -1.32442 9.18966 3.97327 3.9384C9.27096 -1.31287 17.8629 -1.31273 23.1605 3.9384C27.4878 8.23169 28.2782 14.7006 25.5354 19.7889L26.7444 26.0058C26.854 26.5798 26.8657 26.6302 26.2788 26.5178L19.96 25.3116Z",
  fill: "#FDB440"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6137 17.6491C13.0471 17.6491 12.5878 17.1901 12.5878 16.6238V14.6924C12.5878 13.3911 13.4024 12.4262 14.1212 11.5749C14.5906 11.0188 15.0762 10.4438 15.0762 10.0229V8.79741C15.0762 7.62428 14.1112 6.66976 12.9251 6.66976C11.7369 6.66976 10.7701 7.62428 10.7701 8.79741V10.0229C10.7701 10.5892 10.3107 11.0482 9.74417 11.0482C9.17761 11.0482 8.71826 10.5892 8.71826 10.0229V8.79741C8.71826 6.49352 10.6054 4.61914 12.9251 4.61914C15.2426 4.61914 17.128 6.49352 17.128 8.79741V10.0229C17.128 11.1932 16.3636 12.0986 15.6893 12.8972C15.1495 13.5367 14.6396 14.1405 14.6396 14.6924V16.6238C14.6396 17.1901 14.1802 17.6491 13.6137 17.6491Z",
  fill: "#F8F2F0"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6177 22.2654C13.0511 22.2654 12.5918 21.8103 12.5918 21.244V21.2362C12.5918 20.6699 13.0511 20.2109 13.6177 20.2109C14.1843 20.2109 14.6436 20.6699 14.6436 21.2362C14.6436 21.8026 14.1843 22.2654 13.6177 22.2654Z",
  fill: "#F8F2F0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.0887 14.5137C27.3939 10.7286 26.0831 6.83478 23.1605 3.93761C18.8567 -0.324602 12.3853 -1.12745 7.26758 1.53304C11.2467 1.07152 15.3901 2.35528 18.4419 5.38035C21.2981 8.21151 22.6166 11.9928 22.3896 15.7004C22.2761 17.6085 21.7519 19.4972 20.8167 21.227L21.6735 25.6366L26.2787 26.517C26.8656 26.6295 26.8539 26.579 26.7443 26.005L25.5353 19.7881C26.4236 18.136 26.944 16.3364 27.0887 14.5137Z",
  fill: "#FE9900"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M54.8133 23.7379C59.0623 19.526 59.0623 12.7003 54.8133 8.49237C52.2114 5.91329 48.6196 4.91269 45.251 5.4944C47.3794 5.85897 49.4218 6.85958 51.0689 8.49237C55.3141 12.7003 55.3141 19.5262 51.0689 23.7379C50.3686 24.4321 49.5978 25.01 48.7801 25.4753C47.6727 26.1037 46.4755 26.5224 45.251 26.7357C46.6244 26.9723 48.0329 26.9452 49.3982 26.6582C51.382 26.2394 53.2717 25.266 54.8133 23.7379Z",
  fill: "#FE9900"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5119 42.5101C16.329 42.5101 16.1437 42.4612 15.9763 42.3586C15.4933 42.0625 15.3422 41.431 15.6384 40.9484C17.3027 38.2378 20.9288 37.4832 23.4731 38.3195C24.0113 38.4964 24.3041 39.0758 24.1271 39.6137C23.9499 40.1516 23.3699 40.4446 22.8319 40.2672C21.0838 39.6927 18.5053 40.1996 17.3872 42.0208C17.1937 42.3362 16.8568 42.5101 16.5119 42.5101Z",
  fill: "#6D80AA"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M39.4304 46.6675C38.8632 46.6675 38.4033 46.2081 38.4033 45.6413V44.864C38.4033 44.2972 38.8632 43.8379 39.4304 43.8379C39.9977 43.8379 40.4575 44.2973 40.4575 44.864V45.6413C40.4575 46.2081 39.9977 46.6675 39.4304 46.6675Z",
  fill: "#6D80AA"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5359 46.6675C21.9687 46.6675 21.5088 46.2081 21.5088 45.6413V44.864C21.5088 44.2972 21.9687 43.8379 22.5359 43.8379C23.1031 43.8379 23.563 44.2973 23.563 44.864V45.6413C23.563 46.2081 23.1031 46.6675 22.5359 46.6675Z",
  fill: "#6D80AA"
});

var SvgWa = function SvgWa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 68,
    viewBox: "0 0 58 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wa.f784d0d2.svg";
export { ForwardRef as ReactComponent };